/**
 * Central API configuration.
 *
 * Environment files (never commit secrets):
 *   .env.development  → npm start  → http://localhost:2591
 *   .env.production   → npm run build → http://localhost:5000 
 *
 * Override locally without touching the env files:
 *   create .env.local (git-ignored) and set REACT_APP_API_URL=...
 */
const raw = (process.env.REACT_APP_API_URL ?? '').trim();
export const API_BASE      = raw.replace(/\/+$/, '');
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
